import React, { useState } from 'react';
import { FiImage, FiUpload, FiX } from 'react-icons/fi';
import { uploadArticleImage } from '../../services/firebase/blogService';
import { toast } from 'react-hot-toast';

const ImageUploader = ({ initialImage = '', onImageUpload }) => {
  const [image, setImage] = useState(initialImage);
  const [uploading, setUploading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(initialImage);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Dosya türünü kontrol et (sadece resim)
    if (!file.type.match('image.*')) {
      toast.error('Lütfen sadece resim dosyası yükleyin!');
      return;
    }

    // Dosya boyutunu kontrol et (maks. 5MB)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Resim dosyası 5MB\'dan küçük olmalıdır!');
      return;
    }

    // Önizleme URL'si oluştur
    const reader = new FileReader();
    reader.onload = (e) => setPreviewUrl(e.target.result);
    reader.readAsDataURL(file);

    try {
      setUploading(true);
      const imageUrl = await uploadArticleImage(file);
      setImage(imageUrl);
      onImageUpload(imageUrl);
      toast.success('Resim başarıyla yüklendi!');
    } catch (error) {
      console.error('Resim yüklenirken hata:', error);
      toast.error('Resim yüklenirken bir hata oluştu!');
      setPreviewUrl(initialImage); // Hata durumunda önizlemeyi sıfırla
    } finally {
      setUploading(false);
    }
  };

  const handleRemoveImage = () => {
    setImage('');
    setPreviewUrl('');
    onImageUpload('');
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Makale Resmi
      </label>

      <div className="mt-1 flex flex-col items-center justify-center">
        {previewUrl ? (
          <div className="relative w-full h-48 mb-4">
            <img 
              src={previewUrl} 
              alt="Preview" 
              className="w-full h-full object-cover rounded-md"
            />
            <button 
              type="button"
              onClick={handleRemoveImage}
              className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600"
            >
              <FiX size={16} />
            </button>
          </div>
        ) : (
          <div className="w-full h-48 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md flex flex-col items-center justify-center mb-4 hover:border-blue-500 dark:hover:border-blue-400 transition-colors">
            <FiImage size={36} className="text-gray-400" />
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
              Resim yüklemek için tıklayın veya sürükleyin
            </p>
          </div>
        )}

        <input
          type="file"
          id="image-upload"
          accept="image/*"
          onChange={handleImageChange}
          className="hidden"
          disabled={uploading}
        />

        <label
          htmlFor="image-upload"
          className="cursor-pointer py-2 px-4 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 flex items-center justify-center"
        >
          {uploading ? (
            <>
              <span className="animate-spin mr-2">⏳</span>
              Yükleniyor...
            </>
          ) : (
            <>
              <FiUpload className="mr-2" />
              {image ? 'Resmi Değiştir' : 'Resim Yükle'}
            </>
          )}
        </label>
      </div>
    </div>
  );
};

export default ImageUploader;